import * as React from "react"

export interface IJsonLdProps {
  schema: Record<string, unknown> | Record<string, unknown>[]
}

export function JsonLd(props: IJsonLdProps) {
  const { schema } = props
  const schemas = Array.isArray(schema) ? schema : [schema]

  return (
    <>
      {schemas.map((schemaItem, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schemaItem)}
        </script>
      ))}
    </>
  )
}
